module.exports = __webpack_public_path__ + "img/games.1355e332.png";